// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, of, BehaviorSubject, timer } from 'rxjs';

// --- HS Code
import { ProfileBaseService } from './profile-base.service';
import { DemographicValueModel, UserProfileModel, SurveyUserDetailsModel, EmailAddressValidationModel, UserDetailsModel, LanguageModel } from '../../../models';
import { finalize } from 'rxjs/operators';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class ProfileMockService extends ProfileBaseService {
  constructor() {
    super();
  }

  loadProfile(): void {
    const model = {
        firstName: 'Richard',
        lastName: 'Chown',
        emailAddress: 'frikkie@frikadel.com'
    } as UserDetailsModel;
    this._userDetails$.next(model);
    this._isLoaded = true;
  }

  update(
    userDetails: UserProfileModel
  ): Observable<boolean> {
    this._userDetails$.next(null);
    return of (true);
  }

  updateUserDetails(userDetails: UserDetailsModel): void {
    this._userDetails$.next(userDetails);
  }

  updateLoginDetails(loginDetails: UserDetailsModel): void {
    this._userDetails$.next(loginDetails);
  }

  refreshEmailAddress(email: string) {
    if (!this._userDetails$?.value) return;

    this._userDetails$.value.emailAddress = email;
  }

  checkIfEmailAddressInUse(emailAddress: string): void {
    this._isEmailAddressInUse$.next({
      emailAddressExists: false,
      isEmailAddressValidated: true,
      isValidEmailAddress: true
    } as EmailAddressValidationModel);
  }

  updateAvatar(image: string) {
    const currentUserDetails = this._userDetails$.value;
    this._updatingAvatar$.next(true);
    timer(4000)
    .pipe(
      finalize(() => this._updatingAvatar$.next(false)),
    ).subscribe(() => {
      this._avatarUpdated$.next(true);
      if (currentUserDetails) {
        this._userDetails$.next({...currentUserDetails, avatar: image});
      }
    });
  }

  removeAvatar() {
    this._removingAvatar$.next(true);
    timer(2000)
    .pipe(
      finalize(() =>  this._removingAvatar$.next(false)),
    )
    .subscribe(() => {
      this._avatarRemoved$.next(true);
      this._userDetails$.next({...this._userDetails$.value, avatar: ''} as UserDetailsModel);
    });
  }

  requestPasswordChange(): void {
  }
}
